import React from 'react';
import PropTypes from 'prop-types';
import { AccountCheckboxCard, AccountLinkCard } from 'web-ui-components/lib/finance/accounts';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import { payeeTypes } from '../../../config';

const PayeeCardSelector = ({
	listViewSelected,
	handlePayeeSelect,
	getIsPayeeSelected,
	isManageYourPayee,
	handleViewPayee,
	handleDeletePayee,
	handleEditPayee,
	handleEditChaps,
	payee,
	canAddMultiplePayees,
}) => {
	// If accountNumber or sortCode is all 0's, passing string value to web-ui-components.
	const accountNumber = Number(payee.accountNumber) || payee.accountNumber;
	const sortCode = Number(payee.sortCode) || payee.sortCode;

	if (isManageYourPayee) {
		if (payee.type === payeeTypes.INTERNATIONAL) {
			return (
				<AccountLinkCard.International
					onClick={() => handleViewPayee(payee)}
					productNameOrNickname={payee.displayName}
					viewType={listViewSelected ? 'list' : 'grid'}
					IBAN={payee.iban || payee.accountNumber}
					id={payee.id}
				>
					<Inline.LeftAligned
						nodes={[
							<NavigationButton.Tertiary label="Edit" onClick={(event) => handleEditPayee(event, payee)} />,
							<NavigationButton.Tertiary label="Delete" onClick={(event) => handleDeletePayee(event, payee)} />,
						]}
					/>
				</AccountLinkCard.International>
			);
		}
		return (
			<AccountLinkCard.BankAccount
				accountName={payee.displayName}
				onClick={() => handleViewPayee(payee)}
				deleteOnClick={() => handleDeletePayee(payee)}
				editOnClick={() => handleEditPayee(payee)}
				accountNumber={accountNumber}
				sortCode={sortCode}
				id={payee.id}
				viewType={listViewSelected ? 'list' : 'grid'}
				reference={payee.reference}
			>
				<Inline.LeftAligned
					nodes={[
						<NavigationButton.Tertiary label="Edit payee" onClick={(event) => handleEditPayee(event, payee)} />,
						...(payee.type === 'chaps'
							? [
									<NavigationButton.Tertiary
										label="Edit CHAPS Details"
										onClick={(event) => handleEditChaps(event, payee)}
									/>,
							  ]
							: []),
						<NavigationButton.Tertiary label="Delete" onClick={(event) => handleDeletePayee(event, payee)} />,
					]}
				/>
			</AccountLinkCard.BankAccount>
		);
	}
	if (canAddMultiplePayees) {
		if (payee.type === payeeTypes.INTERNATIONAL) {
			return (
				<AccountCheckboxCard.International
					IBAN={payee.iban || payee.accountNumber}
					onClick={() => handlePayeeSelect({ payee, isInternalAccount: false })}
					productNameOrNickname={payee.displayName}
					viewType={listViewSelected ? 'list' : 'grid'}
					isSelected={getIsPayeeSelected(payee.id) || false}
					reference={payee.reference}
					id={payee.id}
				/>
			);
		}
		return (
			<AccountCheckboxCard.BankAccount
				accountNumber={accountNumber}
				onClick={() => handlePayeeSelect({ payee, isInternalAccount: false })}
				productNameOrNickname={payee.displayName}
				sortCode={sortCode}
				viewType={listViewSelected ? 'list' : 'grid'}
				isSelected={getIsPayeeSelected(payee.id) || false}
				reference={payee.reference}
				id={payee.id}
			/>
		);
	}
	if (payee.type === payeeTypes.INTERNATIONAL) {
		return (
			<AccountLinkCard.International
				IBAN={payee.iban || payee.accountNumber}
				onClick={() => handlePayeeSelect({ payee, isInternalAccount: false })}
				productNameOrNickname={payee.displayName}
				viewType={listViewSelected ? 'list' : 'grid'}
				reference={payee.reference}
				id={payee.id}
			/>
		);
	}
	return (
		<AccountLinkCard.BankAccount
			accountNumber={accountNumber}
			onClick={() => handlePayeeSelect({ payee, isInternalAccount: false })}
			productNameOrNickname={payee.displayName}
			sortCode={sortCode}
			viewType={listViewSelected ? 'list' : 'grid'}
			reference={payee.reference}
			id={payee.id}
		/>
	);
};

PayeeCardSelector.propTypes = {
	isManageYourPayee: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	payee: PropTypes.shape(payeePropTypes).isRequired,
	listViewSelected: PropTypes.bool.isRequired,
	handlePayeeSelect: PropTypes.func.isRequired,
	getIsPayeeSelected: PropTypes.func,
	canAddMultiplePayees: PropTypes.bool,
};

export default PayeeCardSelector;
